function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2114",
  transform: "translate(21802 -3211)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_248",
  transform: "translate(-22370 2891)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(568 320)",
  fill: "#eeeff3"
})), /*#__PURE__*/React.createElement("g", {
  id: "article_black_24dp",
  transform: "translate(-21793 3220)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_175",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  d: "M19,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM13,17H8a.945.945,0,0,1-1-1H7a.945.945,0,0,1,1-1h5a.945.945,0,0,1,1,1h0A.945.945,0,0,1,13,17Zm3-4H8a.945.945,0,0,1-1-1H7a.945.945,0,0,1,1-1h8a.945.945,0,0,1,1,1h0A.945.945,0,0,1,16,13Zm0-4H8A.945.945,0,0,1,7,8H7A.945.945,0,0,1,8,7h8a.945.945,0,0,1,1,1h0A.945.945,0,0,1,16,9Z",
  fill: "#f6b900"
})));

var SvgProgramDetails = function SvgProgramDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgramDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/program-details.b8272ac2.svg";
export { ForwardRef as ReactComponent };